import {
  checkLinkForExpiryBasedOnID,
  getConfigurationByName,
} from "api/configuration";
// import { log } from "@craco/craco/lib/logger";
import {
  encryptUrl,
  encryptURLConditionalRedirection,
} from "api/UrlEncryption";
import { LOGIN_ROUTE } from "constants/routes";
import LoadingSpinner from "lib/LoadingSpinner";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { userAuthInfo } from "redux/loggedInUserInfo";

const RouteComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const userToken =
  //   localStorage.getItem("userToken") &&
  //   JSON.parse(localStorage.getItem("userToken"));
  //   const location = useLocation()
  const params = useParams();
  const { profileInfo = null } = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("path");
  const queryLinkBy = React.useMemo(() => {
    return query.get("token");
  }, [search, query]);
    useEffect(() => {
    if (params.branchName) {
      if (queryLinkBy) {
        dispatch(checkLinkForExpiryBasedOnID({ _id: queryLinkBy }))
          .unwrap()
          .then((result) => {
            if (result?.data?.status === "failure") {
              navigate("/error", {
                state: {
                  header: "Link expired",
                  body: "The Link you are trying to access has been expired.Please contact your RM ",
                },
              });
              return;
            }
            dispatch(
              getConfigurationByName({ wf_name: params.branchName })
            ).then((res) => {
              if (res?.meta?.requestStatus === "fulfilled") {
                encryptURLConditionalRedirection(res?.payload?._id || res?.payload?.data?._id).then(
                  (encryptedId) => {
                    if (encryptedId) {
                      if(res?.payload?.data?.dynamic_wf == true){
                        navigate(
                          `/formSubmission/dynamicForms/${encryptedId}${
                            (queryPath && `?${queryPath}=true`) || ""
                          }`
                        );
                      }else{
                      navigate(
                        `/formSubmission/${encryptedId}${
                          (queryPath && `?${queryPath}=true`) || ""
                        }`
                      );
                      }
                    }
                  }
                );
              }
            });
          });
      }
       else {
        dispatch(getConfigurationByName({ wf_name: params.branchName })).then(
          (res) => {
            if (res?.meta?.requestStatus === "fulfilled") { 
              encryptURLConditionalRedirection(res?.payload?._id || res?.payload?.data?._id).then(
                (encryptedId) => {
                  if (encryptedId) {
                    if(res?.payload?.data?.dynamic_wf == true){
                      navigate(
                        `/formSubmission/dynamicForms/${encryptedId}${
                          (queryPath && `?${queryPath}=true`) || ""
                        }`
                      );
                    }
                    else{
                    navigate(
                      `/formSubmission/${encryptedId}${
                        (queryPath && `?${queryPath}=true`) || ""
                      }`
                    );
                    }
                  }
                }
              );
            }
          }
        );
      }
    }
  }, [params.branchName]);
  
  return (
    <>
      {" "}
      <LoadingSpinner />
    </>
  );
};

export default RouteComponent;
